import React from 'react';
import { DetailFieldProps } from './types';
import { styles } from './styles';

const DetailField: React.FC<DetailFieldProps> = ({ label, children, className }) => (
  <div className={className}>
    <span className={styles.label}>{label}</span>
    <div className={styles.value}>{children}</div>
  </div>
);

export default DetailField;
export type { DetailFieldProps } from './types';
